import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-container title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "All Stores")
  ])
], -1)
const _hoisted_2 = { class: "container criteria" }
const _hoisted_3 = { class: "flex group" }
const _hoisted_4 = { class: "flex flex-0 firstgroup" }
const _hoisted_5 = { class: "flex flex-column generate dropdown" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "selectedReport" }, "Report to Generate", -1)
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"width":"0.5rem"} }, null, -1)
const _hoisted_9 = { class: "flex flex-column filter dropdown" }
const _hoisted_10 = {
  key: 0,
  for: "selectedFields"
}
const _hoisted_11 = { class: "flex align-items-end submit" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "flex-grow-1 table" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Loading Reports "),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" })
], -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "container flex-grow-1"
}

import SalesSummary from './ReportEnterpriseItems/SalesSummary.vue';
  import ServiceAdvisorSummary from './ReportEnterpriseItems/ServiceAdvisorSummary.vue';
  import TechnicianSummary from './ReportEnterpriseItems/TechnicianSummary.vue';
  import { ref, onMounted, computed } from "vue";
  import { useAuth0 } from "@auth0/auth0-vue";
  import { openErrorModal } from '@/composables/useErrorLog';
  import ErrorModal from './ErrorModal.vue';
  import moment from 'moment';
  import DataTable from "primevue/datatable";
  import { getTechnicianSummaryEnterprise, getServiceAdvisorSummaryEnterprise, getSalesSummaryEnterprise, getReportButton, updateButtonReport } 
    from '@/composables/useInputParameters';
  import { useStore } from 'vuex';

  
export default /*#__PURE__*/_defineComponent({
  name: 'Enterprise',
  setup(__props) {

  const store = useStore();
  const empty = ref(false);
  const loading = ref(false);
  const startDate = ref(moment().startOf('month').format('MM/DD/YYYY'));
  const selectedFields = ref();
  const fields = ref([]);
  const overallTotal = ref();
  const endDate = ref(moment().endOf('month').format('MM/DD/YYYY'));
  const reports = ref([
    {
      label: 'Data Sets',
      items: [
          { label: '  Technician Summary', value: 'PWATechnicianSummaryEnterprise', component: TechnicianSummary, input: getTechnicianSummaryEnterprise },
          { label: '  Service Advisor Summary', value: 'PWAServiceAdvisorSummaryEnterprise', component: ServiceAdvisorSummary, input: getServiceAdvisorSummaryEnterprise },
          { label: '  Sales Summary', value: 'PWASalesSummaryEnterprise', component: SalesSummary, input: getSalesSummaryEnterprise }
      ]
    }
  ]);

  const selectedReport = ref('');
  const reportData = ref([]);
  const auth0 = useAuth0();
  const dynamicColumns = computed(() => {
    return Array.isArray(selectedFields.value)
      ? [...selectedFields.value].sort((a, b) => a.rank - b.rank)
      : [];
  });
  const initialLoad = ref(true);
  const reportTitle = ref('');
  const storename = ref();

  onMounted(async () => {
    storename.value = store.state.storename;
  });

  const getReport = async () => {
    if (!startDate.value || !endDate.value || !selectedReport.value) return;
    try {
      reportTitle.value = 'Loading Report';
      selectedFields.value = [];
      reportData.value = [];
      fields.value = [];
      loading.value = true;
      const storeid = store.state.storeid;
      const enterpriseid = store.state.enterpriseid;
      const queryParameters = selectedReport.value.input();
      const url = `${process.env.VUE_APP_NODEJS_BASE_URL}reporting/${enterpriseid}/${storeid}/${selectedReport.value.value}?${queryParameters}`;
      const accessToken = await auth0.getAccessTokenSilently();
      const response: Response = await fetch(url, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'Accept-Encoding': 'gzip'
          },
      });

      const data = await response.json();

      if (response.status > 400) {
          throw new Error(JSON.stringify(data.error));
      }

      if(data.message.length === 0) {
        empty.value = true;
        reportData.value = [];
        return;
      }

      reportData.value = data.message.reportData;
      fields.value = data.message.fields;
      overallTotal.value = undefined;
      const index = reportData.value.findIndex(item => item.ServiceCategory === "Total");
      if (index !== -1) {
        overallTotal.value = reportData.value.splice(index, 1)[0];
      } else {
        overallTotal.value = getOverAllTotal(fields.value, reportData.value);
      }
      selectedFields.value = [...fields.value];
      empty.value = false;
      loading.value = false;
      getReportButton.value = false;
      initialLoad.value = false;
      reportTitle.value = selectedReport.value.label;
    } catch (e) {
        openErrorModal(e.message);
    }
  };

  const getTotalData = (field) => {
    const value = overallTotal.value[field.fieldid];
    if (field.format === 'currency') {
      return formatCurrency(value);
    } else if (field.format === 'percentage') {
      return formatPercentage(value);
    } else if (field.format === 'decimal') { // for labor hours, since we cannot determine if it is currency or percentage
      return `${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    } else if (field.format === 'integer') {
      return value;
    }

    return value;
  };

  const formatCurrency = (value) => {
      if (value != '') {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      }
      return value;
  };

  const formatPercentage = (value) => {
      if (value != '') {
        const transformedValue = value * 100;
        return `${transformedValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
      }
      return value;
  };

  const formatUndefinedValue = (value) => {
      if (value != '') {
        return `${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
      return value;
  };

  const getOverAllTotal = (fields, reportData) => {
    const summationData = {};
    fields.forEach(field => { summationData[field.fieldid] = field.summation; });
    const totals = reportData.reduce((acc, curr) => 
      {
        for (let index = 0; index < fields.length; index++) {
          if (fields[index].summation === 0) {
            acc[fields[index].fieldid] += curr[fields[index].fieldid];
          } else {
            acc[fields[index].fieldid] = fields[index].summation; // get default summation if field cannot be summed
          }
        }
        return acc;
      },
      { ...summationData } // default data if no reportData
    );

    fields.forEach(field => {
      const fieldid = field.fieldid;
      if (field.summation === 0 && field.format === 'percentage') {
        totals[fieldid] = reportData.length > 0 ? totals[fieldid] / reportData.length : 0;
      }
    });

    if (totals['InvoiceTotal'] === 0) {
      totals['MarginPercent'] = 0;  
    } else {
      const valtest = ((totals['PartsTotal'] + totals['LaborTotal'] + totals['SubletTotal']) -
      (totals['PartsCost'] + totals['LaborCost'] + totals['SubletCost'])) / (totals['PartsTotal'] + totals['LaborTotal'] + totals['SubletTotal'])
      totals['MarginPercent'] = valtest;
    }
    
    return totals;
  }

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Dropdown, {
              disabled: loading.value,
              modelValue: selectedReport.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReport).value = $event)),
              options: reports.value,
              optionLabel: "label",
              optionGroupLabel: "label",
              optionGroupChildren: "items",
              placeholder: "Select a Report",
              class: "w-full md:w-14rem",
              onChange: _unref(updateButtonReport)
            }, {
              optiongroup: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createTextVNode(_toDisplayString(slotProps.option.label), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled", "modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (fields.value.length > 0)
              ? (_openBlock(), _createElementBlock("label", _hoisted_10, "Filter Columns"))
              : _createCommentVNode("", true),
            (fields.value.length > 0)
              ? (_openBlock(), _createBlock(_component_MultiSelect, {
                  key: 1,
                  modelValue: selectedFields.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedFields).value = $event)),
                  options: fields.value,
                  maxSelectedLabels: 3,
                  optionLabel: "fieldname",
                  placeholder: "Select Columns",
                  showToggleAll: false
                }, null, 8, ["modelValue", "options"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(selectedReport.value.component), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              (_unref(getReportButton))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: initialLoad.value ? 'Submit' : 'Update',
                    class: "p-button p-component p-button-rounded btn-primary sml",
                    style: {"height":"35px"},
                    onClick: getReport
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("h3", null, _toDisplayString(reportTitle.value), 1),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(DataTable), {
            responsiveLayout: "stack",
            value: reportData.value,
            paginator: true,
            rows: 10,
            stripedRows: "",
            removableSort: "",
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            rowsPerPageOptions: [10, 20, 50],
            breakpoint: "800px",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
            selectionMode: "single",
            loading: loading.value,
            dataKey: "ServiceCategory"
          }, {
            loading: _withCtx(() => [
              _hoisted_15
            ]),
            empty: _withCtx(() => [
              (initialLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Select a Report"))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "No Reports Found"))
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dynamicColumns), (column) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  key: column.fieldid,
                  field: column.fieldid,
                  header: column.fieldname,
                  sortable: true
                }, _createSlots({ _: 2 }, [
                  (column.format === 'currency')
                    ? {
                        name: "body",
                        fn: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(formatCurrency(slotProps.data[column.fieldid])), 1)
                        ])
                      }
                    : (column.format === 'percentage')
                      ? {
                          name: "body",
                          fn: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(formatPercentage(slotProps.data[column.fieldid])), 1)
                          ])
                        }
                      : (column.format === 'decimal')
                        ? {
                            name: "body",
                            fn: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(formatUndefinedValue(slotProps.data[column.fieldid])), 1)
                            ])
                          }
                        : (column.format === undefined)
                          ? {
                              name: "body",
                              fn: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(formatUndefinedValue(slotProps.data[column.fieldid])), 1)
                              ])
                            }
                          : undefined,
                  (overallTotal.value)
                    ? {
                        name: "footer",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getTotalData(column)), 1)
                        ])
                      }
                    : undefined
                ]), 1032, ["field", "header"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "loading"]),
          (empty.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, "No reports found."))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})